import { useCallback, useMemo } from 'react';
import { useI18n } from '@namespace/i18n';
import { useUserSegmentsIncludes } from '@namespace/segments';

export const useFilteredBannerSlides = ({
  slides = [],
  showOnlyFirstSlide = false
}) => {
  const { f } = useI18n();
  const filterSegments = useUserSegmentsIncludes();

  const filterByShowTime = useCallback(
    ({ from, to }) => {
      if (from || to) {
        return f.localTimeIsActual(from, to, f.getDateTime);
      }
      return true;
    },
    [f]
  );

  return useMemo(() => {
    const filtered = slides.filter(
      (slide) => filterByShowTime(slide) && filterSegments(slide.userSegments)
    );
    return showOnlyFirstSlide ? [filtered[0]] : filtered;
  }, [slides, showOnlyFirstSlide, filterByShowTime, filterSegments]);
};
